var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgressAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 36,
    viewBox: "0 0 52 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 13.4615,
    height: 35,
    rx: 2,
    fill: "#212A35",
    stroke: "#212A35"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.03809,
    y: 0.5,
    width: 45.7692,
    height: 35,
    rx: 2,
    fill: "white",
    stroke: "#212A35"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 22.8457V14.4374H16.5703V22.8457",
    stroke: "#212A35",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1807 22.8472V10.8354H21.376V22.8472",
    stroke: "#212A35",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5743 22.8462V7.23077H11.7695V22.8462",
    stroke: "#212A35",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7695 22.8483H27.3849",
    stroke: "#212A35",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7536 22.707C41.4431 22.707 44.434 19.8016 44.434 16.2175H37.7536L37.7537 9.72808C34.0642 9.72805 31.0732 12.6335 31.0732 16.2175C31.0732 19.8016 34.0641 22.707 37.7536 22.707Z",
    fill: "#68E4FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6763 8.51119V13.3159H45.269V12.9727C45.269 10.5087 43.2128 8.51119 40.6763 8.51119Z",
    fill: "#68E4FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7536 22.707C41.4431 22.707 44.434 19.8016 44.434 16.2175H37.7536L37.7537 9.72808C34.0642 9.72805 31.0732 12.6335 31.0732 16.2175C31.0732 19.8016 34.0641 22.707 37.7536 22.707Z",
    stroke: "#212A35",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6763 8.51119V13.3159H45.269V12.9727C45.269 10.5087 43.2128 8.51119 40.6763 8.51119Z",
    stroke: "#212A35",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12.2744,
    y1: 29.3025,
    x2: 46.7639,
    y2: 29.3025,
    stroke: "#212A35",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressAnalysis);
export default __webpack_public_path__ + "static/media/progressAnalysis.02f20787f691f862be56bf80f9afca2e.svg";
export { ForwardRef as ReactComponent };